import { useEffect, useState } from 'react';
import { Frame } from '@/lib/polaris';
import { Box, InlineStack, Spinner, Text } from '@/lib/polaris';
import { Topbar } from './Topbar';

const BODY_ADMIN_CLASS = 'polaris-admin';

/** Layout de carga del admin: TopBar + Spinner. Evita barra negra al refrescar. */
export function AdminLoadingLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add(BODY_ADMIN_CLASS);
    return () => document.body.classList.remove(BODY_ADMIN_CLASS);
  }, []);

  return (
    <Frame
      topBar={<Topbar onNavigationToggle={() => setMobileNavOpen(true)} />}
      showMobileNavigation={mobileNavOpen}
      onNavigationDismiss={() => setMobileNavOpen(false)}
    >
      <Box padding="800" minHeight="70vh">
        <InlineStack align="center" blockAlign="center">
          <Box padding="800">
            <InlineStack align="center" blockAlign="center" gap="300">
              <Spinner accessibilityLabel="Cargando" size="large" />
              <Text as="p" tone="subdued">
                Cargando...
              </Text>
            </InlineStack>
          </Box>
        </InlineStack>
      </Box>
    </Frame>
  );
}
